import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';
import { SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { CodeItem } from './../../../common/interfaces/code-item.interface';
import { CommonProgrammingContext } from '../../../common/services/shared-programming.service';
import { Event } from '../../../common/interfaces/event.interface';

@Component({
  selector: 'prg-code-item,[prg-code-item]',
  templateUrl: './code-item.component.html',
  styleUrls: ['./code-item.component.less']
})
export class CodeItemComponent implements OnInit {

  @Input() codeItem: any;
  @Input() event: Event;

  adding: Observable<boolean>;
  editing: Observable<boolean>;

  private _currentAction: any;
  private _showConfirmDelete: boolean = false;

  constructor(
    private shared: SharedProgrammingService,
    private utils: Utils,
    private store: Store<{ sharedProgramming: CommonProgrammingContext }>
  ) {
    this.editing = this.store.select(s => s.sharedProgramming.editing);
    this.adding = this.store.select(s => s.sharedProgramming.adding);
  }

  ngOnInit() {

  }

  private showConfirmDelete(state: boolean) {
    this._showConfirmDelete = state;
  }

  confirmDelete() {
    console.log('confirming delete for', this.codeItem);
    let editing = Utils.snapshot(this.editing);
    if (editing && !this.codeItem.protected) {
      this._currentAction = this.codeItem;
      this.showConfirmDelete(true);
    }
  }

  private _toggleEnabled(codeitem: CodeItem) {
    console.log('codeitem: toggling enabled for', codeitem);
    this.shared.toggleCodeitemEnabled(codeitem);
  }

  private deleteCodeItem() {
    this.showConfirmDelete(false);
    console.log('evt-codeitems: deleting action', this._currentAction);
    this.shared.deleteAction(this._currentAction);
    this._currentAction = null;
  }

  private toggleCodeitem() {
    this.shared.toggleCodeitemEnabled(this.codeItem);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/code-item/code-item.component.ts